/**
 * PanelEmptyState - The Intelligent Standard
 *
 * Empty state display for panel contexts.
 * Shows icon, title, and description in a centered layout.
 */

import { ReactNode } from 'react';

import { IconCircle } from './IconCircle';

export interface PanelEmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  /** When true, renders without outer container (for embedded use) */
  embedded?: boolean;
}

export function PanelEmptyState({
  icon,
  title,
  description,
  embedded = false,
}: PanelEmptyStateProps) {
  const content = (
    <div className="text-center p-8">
      <IconCircle icon={icon} backgroundColor="#F5F0EB" />
      <p className="text-sm font-medium" style={{ color: '#1A1A1A' }}>
        {title}
      </p>
      <p className="text-sm" style={{ color: '#6B6B6B' }}>
        {description}
      </p>
    </div>
  );

  if (embedded) {
    return content;
  }

  return (
    <div
      className="h-full rounded-xl flex items-center justify-center"
      style={{
        background: '#FFFFFF',
        border: '1px solid #E8E0D8',
      }}
    >
      {content}
    </div>
  );
}
